import { frontendURL } from '../../../helper/URLHelper';
import HomePage from './HomePage.vue';

const meta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/home'),
    name: 'dashboard_home',
    meta,
    component: HomePage,
  },
];
